/* eslint-disable @typescript-eslint/no-explicit-any */
const contactUsPayload = (href: string | null) => {
  if (href === null) return {};
  let contactType = 'chat';

  if (href.includes('contact-us/')) {
    contactType = 'send message';
  } else if (href.includes('mailto')) {
    contactType = 'email';
  } else if (href.includes('tel')) {
    contactType = 'phone';
  } else if (href.includes('fax')) {
    contactType = 'fax';
  }

  return {event: 'contact_us', contact_type: contactType};
};

const contactUsLinkClickCallback = (event: Event) => {
  (window as any).dataLayer?.push(contactUsPayload((event.target as HTMLAnchorElement).href));
};

export default contactUsLinkClickCallback;
